import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { Router } from '@angular/router';
import { NotificationService } from '@shared/services/notifications/notification.service';
import { finalize } from 'rxjs/operators';
import { AppFormFieldErrorDirective } from '@shared/directives/app-form-field-error.directive';

import { AuthFirebaseService } from '@core/services/auth-firebase/auth-firebase.service';
import { MultiFactorError } from '@angular/fire/auth';
import { TwoFactorAuthenticationService } from '../two-factor-authentication/service/two-factor-authentication.service';
import { getFirebaseErrorMessage } from '@core/services/auth-firebase/firebase-error-map';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule, AppFormFieldErrorDirective],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  hidePassword: boolean = true; 
  submitting: boolean = false;

  constructor(
    private fb: FormBuilder,
    private authFirebaseService: AuthFirebaseService,
    private notificationService: NotificationService,
    private router: Router,
    private twoFactorService: TwoFactorAuthenticationService
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
        ],
      ],
    });
  }

  ngOnInit(): void {}

  onHandleMultiFactorAuth(error: MultiFactorError): void {
    this.twoFactorService.setResolver(error);
    this.router.navigate(['/mfa-login']);
  }

  onSubmit(): void {
    if (this.loginForm.invalid) return;

    this.submitting = true;

    this.authFirebaseService
      .login(this.loginForm.value)
      .pipe(finalize(() => (this.submitting = false)))
      .subscribe({
        next: () => {
          this.router.navigate(['/dashboard']);
        },
        error: (error: any) => {
          if (error.code === 'auth/multi-factor-auth-required') {
            this.onHandleMultiFactorAuth(error);
            return;
          }

          this.notificationService.show(
            'Error',
            'Error al iniciar sesión - detalles: ' +
              getFirebaseErrorMessage(error.code),
            'error'
          );
        },
      });
  }

  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
  }
}